(function (root) {
  'use strict';

  var CONTRACT_ID = 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_1';
  var STANDARD_ID = 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.0.3';
  var FURNITURE_CONTRACT_ID = 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_2';
  var FURNITURE_STANDARD_ID = 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.1.0';
  var TOP_LEVEL = new Set([
    'PROJECTION_ID', 'PRODUCT_STANDARD', 'PRODUCT_CATEGORY', 'PARENT_ID',
    'SHOPIFY_PRODUCT_GID', 'HANDLE', 'PRODUCT_CLASS', 'MASTER_REF',
    'MEDIA_ASSETS', 'FACTS', 'EFFECTIVE_LIGHTING_FACTS', 'VARIANT_BINDINGS',
    'SHOPIFY_PRODUCT_TYPE', 'CLASS_MAPPING_APPROVAL_STATE',
    'CLASS_MAPPING_SOURCE_REF', 'KEY_DETAILS_ITEMS', 'APPLICABILITY_RULES', 'SELECTED_ROOM_SLOT'
  ]);
  var ITEM_KEYS = new Set([
    'SOURCE_TYPE', 'SOURCE_FACT_REF', 'DISPLAY_ORDER', 'APPLICABLE_VARIANT_GIDS'
  ]);

  function object(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function nonblank(value) {
    return typeof value === 'string' && value.trim().length > 0;
  }


  function adapter() {
    return root ? root.AorvoPdpContractAdapter : require('./aorvo-pdp-contract-adapter.js');
  }

  function renderDimensions(rootNode, selectedVariantId) {
    if (!rootNode || !adapter()) return;
    function clearInvalidDimensions() {
      rootNode.querySelectorAll('[data-aorvo-configuration-dimension], [data-aorvo-configuration-key], [data-aorvo-approved-dimension-context]').forEach(function (row) { row.remove(); });
    }
    var projection;
    try { projection = JSON.parse(rootNode.getAttribute('data-aorvo-projection-payload') || ''); }
    catch (_) { clearInvalidDimensions(); return; }
    if (!object(projection) || !Array.isArray(projection.FACTS)) { clearInvalidDimensions(); return; }
    var result = adapter().configurationDimensions(projection, 'gid://shopify/ProductVariant/' + String(selectedVariantId));
    var dimensionModule = rootNode.querySelector('[data-aorvo-decision-role="Dimension / Scale"]');
    var figure = dimensionModule && dimensionModule.querySelector('[data-aorvo-approved-role="Dimension / Scale"]');
    var model = rootNode.aorvoPdpViewModel;
    if (figure && model && model.attestationVerified === true &&
        rootNode.aorvoPdpVerifiedPayload === rootNode.getAttribute('data-aorvo-projection-payload') &&
        model.productIdentity === projection.SHOPIFY_PRODUCT_GID && model.parentId === projection.PARENT_ID) {
      var records = projection.MEDIA_ASSETS.filter(function (item) {
        return item.MEDIA_ROLE === 'Dimension / Scale' && item.SHOPIFY_MEDIA_GID === 'gid://shopify/MediaImage/' + figure.getAttribute('data-aorvo-source-id');
      });
      if (records.length === 1) {
        var applicability = adapter().resolveReferenceApplicability(projection, records[0], 'gid://shopify/ProductVariant/' + String(selectedVariantId));
        figure.hidden = applicability.hidden;
        figure.style.setProperty('display', figure.hidden ? 'none' : '', figure.hidden ? 'important' : '');
        dimensionModule.querySelectorAll('.aorvo-pdp-canary__room-context').forEach(function (node) {
          if (node.textContent.trim() === applicability.contextLabel) node.hidden = figure.hidden;
        });
      }
    }
    var aggregate = projection.FACTS.find(function (fact) { return fact.FIELD_ID === 'meaningful_dimensions' && fact.FACT_GROUP === 'DIMENSIONS'; });
    var summary = rootNode.querySelector('.aorvo-pdp-canary__key-details:not([data-aorvo-key-details-mode]) ul');
    if (rootNode.getAttribute('data-aorvo-native-commerce') === 'true' && summary) {
      summary.querySelectorAll('[data-aorvo-configuration-key], [data-aorvo-key-fact]').forEach(function (row) {
        if (row.hasAttribute('data-aorvo-configuration-key') ||
            (result.status !== 'ABSENT' && aggregate && row.getAttribute('data-aorvo-key-fact') === aggregate.FACT_ID)) row.remove();
      });
    }
    if (result.status === 'ABSENT') {
      if (dimensionModule) dimensionModule.querySelectorAll('[data-aorvo-configuration-dimension], [data-aorvo-approved-dimension-context]').forEach(function (row) { row.remove(); });
      return;
    }
    // The legacy summary consumes the same selected fact as Dimensions & Fit.
    if (rootNode.getAttribute('data-aorvo-native-commerce') === 'true' && summary) {
      if (result.status === 'OK' && result.items.length) {
        var item = result.items[0], row = document.createElement('li');
        row.setAttribute('data-aorvo-configuration-key', result.factId);
        var label = document.createElement('span'), value = document.createElement('span');
        label.className = 'aorvo-pdp-key-label'; value.className = 'aorvo-pdp-key-value';
        label.textContent = item.label + ':'; value.textContent = item.text;
        row.append(label, document.createTextNode(' '), value); summary.prepend(row);
      }
    }
    var module = rootNode.querySelector('[data-aorvo-decision-role="Dimension / Scale"]');
    var list = module && module.querySelector('dl');
    // Liquid may omit a list for a modern approved aggregate lacking legacy SOURCE_REFERENCE.
    // The existing renderer can create that host only from a verified current Adapter payload.
    if (!list && module && result.status === 'OK' && result.items.length &&
        model && model.attestationVerified === true && model.productIdentity === projection.SHOPIFY_PRODUCT_GID &&
        model.parentId === projection.PARENT_ID && rootNode.aorvoPdpVerifiedPayload === rootNode.getAttribute('data-aorvo-projection-payload')) {
      var body = module.querySelector('.aorvo-pdp-decision-module__body');
      if (body) { list = document.createElement('dl'); list.className = 'aorvo-pdp-material-facts'; body.append(list); }
    }
    if (!list) return;
    list.querySelectorAll('[data-aorvo-fact-id]').forEach(function (row) {
      if (row.hasAttribute('data-aorvo-configuration-dimension') ||
          row.getAttribute('data-aorvo-fact-id') === result.factId ||
          result.items.some(function (item) { return row.getAttribute('data-aorvo-fact-id') === item.factId; }) ||
          (aggregate && row.getAttribute('data-aorvo-fact-id') === aggregate.FACT_ID)) row.remove();
    });
    var items = result.status === 'OK' ? result.items : [];
    if (result.status === 'OK' && !items.length && aggregate) {
      var fallback = approvedSource(aggregate, 'FACT', projection.PARENT_ID);
      if (fallback) items = [fallback];
    }
    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      var row = document.createElement('div');
      var label = document.createElement('dt');
      var value = document.createElement('dd');
      row.className = 'aorvo-pdp-fact';
      row.setAttribute('data-aorvo-fact-id', item.factId);
      row.setAttribute('data-aorvo-configuration-dimension', result.variantCan || '');
      label.textContent = item.label;
      value.textContent = item.text;
      row.append(label, value);
      fragment.append(row);
    });
    list.prepend(fragment);
    module.querySelectorAll('[data-aorvo-approved-dimension-context]').forEach(function (row) { row.remove(); });
    if (result.status === 'OK' && result.approvedContextText) {
      var context = document.createElement('p');
      context.setAttribute('data-aorvo-approved-dimension-context', '');
      context.textContent = result.approvedContextText;
      module.querySelector('.aorvo-pdp-decision-module__body').append(context);
    }
  }

  function approvedSource(source, type, parent) {
    if (!object(source) || source.PARENT_ID !== parent ||
        !nonblank(source.FACT_REF) || !nonblank(source.SOURCE_AUTHORITY) ||
        source.APPROVAL_STATE !== 'APPROVED' || source.QA_STATE !== 'PASS' ||
        source.CURRENT !== 'YES') return null;
    if (type === 'FACT') {
      if (!nonblank(source.FACT_ID) || !nonblank(source.FIELD_ID) ||
          !(nonblank(source.SOURCE_REFERENCE) || (Array.isArray(source.SOURCE_REFERENCE) && source.SOURCE_REFERENCE.length > 0)) ||
          source.DISPLAY_APPROVAL_STATE !== 'APPROVED' ||
          !nonblank(source.APPROVED_DISPLAY_LABEL) ||
          !nonblank(source.APPROVED_DISPLAY_TEXT)) return null;
      return {
        label: source.APPROVED_DISPLAY_LABEL,
        text: source.APPROVED_DISPLAY_TEXT,
        factId: source.FACT_ID
      };
    }
    if (!nonblank(source.FACT_ID) || !nonblank(source.SOURCE_VERSION) ||
        !nonblank(source.SOURCE_HASH_OR_RECEIPT) ||
        source.CUSTOMER_TEXT_APPROVAL_STATE !== 'APPROVED' ||
        !nonblank(source.APPROVED_CUSTOMER_LABEL) ||
        !nonblank(source.APPROVED_CUSTOMER_TEXT)) return null;
    return {
      label: source.APPROVED_CUSTOMER_LABEL,
      text: source.APPROVED_CUSTOMER_TEXT,
      factId: source.FACT_ID
    };
  }

  function resolve(projection, selectedVariantId) {
    var empty = { status: 'INVALID_CONTRACT', items: [] };
    var oneRoom = object(projection) && projection.PROJECTION_ID === 'AORVO_PRODUCT_STOREFRONT_PROJECTION_CANDIDATE_V1_3' &&
      projection.PRODUCT_STANDARD === 'AORVO_PRODUCT_UNIFIED_STANDARD_V2.1.1';
    var furniture = object(projection) && projection.PROJECTION_ID === FURNITURE_CONTRACT_ID &&
      projection.PRODUCT_STANDARD === FURNITURE_STANDARD_ID && projection.PRODUCT_CATEGORY === 'FURNITURE';
    furniture = furniture || (oneRoom && projection.PRODUCT_CATEGORY === 'FURNITURE');
    var lighting = object(projection) && projection.PROJECTION_ID === CONTRACT_ID &&
      projection.PRODUCT_STANDARD === STANDARD_ID && projection.PRODUCT_CATEGORY === 'LIGHTING';
    lighting = lighting || (oneRoom && projection.PRODUCT_CATEGORY === 'LIGHTING');
    if ((oneRoom && lighting && !['ROOM_01', 'ROOM_02'].includes(projection.SELECTED_ROOM_SLOT)) ||
        (!oneRoom && Object.prototype.hasOwnProperty.call(projection || {}, 'SELECTED_ROOM_SLOT'))) return empty;
    if ((!furniture && !lighting) || (furniture && (!Array.isArray(projection.EFFECTIVE_LIGHTING_FACTS) || projection.EFFECTIVE_LIGHTING_FACTS.length !== 0)) ||
        !nonblank(projection.PARENT_ID) ||
        [...TOP_LEVEL].some(function (key) {
          return key !== 'KEY_DETAILS_ITEMS' && key !== 'APPLICABILITY_RULES' && key !== 'SELECTED_ROOM_SLOT' &&
            !Object.prototype.hasOwnProperty.call(projection, key);
        }) ||
        Object.keys(projection).some(function (key) { return !TOP_LEVEL.has(key); }) ||
        !Array.isArray(projection.FACTS) ||
        !Array.isArray(projection.EFFECTIVE_LIGHTING_FACTS) ||
        !Array.isArray(projection.VARIANT_BINDINGS)) return empty;

    if (!Object.prototype.hasOwnProperty.call(projection, 'KEY_DETAILS_ITEMS')) {
      return { status: 'OK_EMPTY', items: [] };
    }
    var selection = projection.KEY_DETAILS_ITEMS;
    if (!Array.isArray(selection) || (furniture && selection.length > 3)) return empty;

    var orders = new Set();
    var references = new Set();
    var approvedVariants = new Set(projection.VARIANT_BINDINGS
      .filter(function (binding) {
        return object(binding) && binding.CURRENT_APPROVED === 'YES' &&
          /^gid:\/\/shopify\/ProductVariant\/[0-9]+$/.test(binding.SHOPIFY_VARIANT_GID);
      })
      .map(function (binding) { return binding.SHOPIFY_VARIANT_GID; }));
    var selectedGid = 'gid://shopify/ProductVariant/' + String(selectedVariantId);
    var dimensions = adapter() && adapter().configurationDimensions(projection, selectedGid);
    var dimensionRefs = new Set(projection.FACTS.filter(function (fact) { return fact && ['meaningful_dimensions', 'dimension_semantics'].includes(fact.FIELD_ID); }).map(function (fact) { return fact.FACT_REF; }));
    if (dimensions && dimensions.status === 'INVALID_CONFIGURATION_DIMENSIONS' && selection.some(function (item) { return item && dimensionRefs.has(item.SOURCE_FACT_REF); })) return empty;
    var sorted = [];

    for (var index = 0; index < selection.length; index += 1) {
      var item = selection[index];
      if (!object(item) ||
          Object.keys(item).some(function (key) { return !ITEM_KEYS.has(key); }) ||
          (furniture ? item.SOURCE_TYPE !== 'FACT' : !['FACT', 'EFFECTIVE_LIGHTING_FACT'].includes(item.SOURCE_TYPE)) ||
          !nonblank(item.SOURCE_FACT_REF) ||
          !Number.isInteger(item.DISPLAY_ORDER) || item.DISPLAY_ORDER < 1 ||
          orders.has(item.DISPLAY_ORDER) ||
          references.has(item.SOURCE_TYPE + '\u0000' + item.SOURCE_FACT_REF)) return empty;
      orders.add(item.DISPLAY_ORDER);
      references.add(item.SOURCE_TYPE + '\u0000' + item.SOURCE_FACT_REF);

      if (Object.prototype.hasOwnProperty.call(item, 'APPLICABLE_VARIANT_GIDS')) {
        var gids = item.APPLICABLE_VARIANT_GIDS;
        if (!Array.isArray(gids) || gids.length === 0 ||
            new Set(gids).size !== gids.length ||
            gids.some(function (gid) {
              return typeof gid !== 'string' ||
                !/^gid:\/\/shopify\/ProductVariant\/[0-9]+$/.test(gid) ||
                !approvedVariants.has(gid);
            })) return empty;
        if (!gids.includes(selectedGid)) continue;
      }

      var pool = item.SOURCE_TYPE === 'FACT' ?
        projection.FACTS : projection.EFFECTIVE_LIGHTING_FACTS;
      var matches = pool.filter(function (source) {
        return object(source) && source.FACT_REF === item.SOURCE_FACT_REF;
      });
      if (matches.length !== 1) {
        if (furniture) return empty;
        continue;
      }
      var source = matches[0];
      if (item.SOURCE_TYPE === 'EFFECTIVE_LIGHTING_FACT' && source.FACT_ID === 'SLOPED_CEILING_SUPPORT' &&
          (!adapter() || !adapter().slopedCeilingEligible(projection, source))) continue;
      if (item.SOURCE_TYPE === 'FACT' && source.FIELD_ID === 'meaningful_dimensions' &&
          dimensions && dimensions.status === 'INVALID_CONFIGURATION_DIMENSIONS') continue;
      var display = approvedSource(source, item.SOURCE_TYPE, projection.PARENT_ID);
      if (item.SOURCE_TYPE === 'FACT' && source.FIELD_ID === 'meaningful_dimensions' &&
          dimensions && dimensions.status === 'OK' && dimensions.items.length) {
        display = { label: dimensions.items[0].label, factId: dimensions.factId,
          text: dimensions.items.map(function (row, index) {
            return index === 0 ? row.text : row.label + ': ' + row.text;
          }).join('; ') };
      }
      if (!display) {
        if (furniture) return empty;
        continue;
      }
      sorted.push({
        order: item.DISPLAY_ORDER,
        sourceType: item.SOURCE_TYPE,
        sourceRef: item.SOURCE_FACT_REF,
        factId: display.factId,
        label: display.label,
        text: display.text
      });
    }
    sorted.sort(function (a, b) { return a.order - b.order; });
    return { status: 'OK', items: sorted.slice(0, 3) };
  }


  function renderSelectedConfigurationContext(rootNode, selectedVariantId) {
    if (!rootNode || !adapter()) return;
    rootNode.querySelectorAll('[data-aorvo-selected-configuration-context]').forEach(function (node) { node.remove(); });
    var projection, variants;
    try {
      projection = JSON.parse(rootNode.getAttribute('data-aorvo-projection-payload') || '');
      var source = rootNode.querySelector('[data-aorvo-variants]');
      variants = JSON.parse(source ? source.textContent : '[]');
    } catch (_) { return; }
    var model = rootNode.aorvoPdpViewModel;
    if (!model || model.productIdentity !== projection.SHOPIFY_PRODUCT_GID || model.parentId !== projection.PARENT_ID ||
        (model.attestationVerified && rootNode.aorvoPdpVerifiedPayload !== rootNode.getAttribute('data-aorvo-projection-payload')) ||
        (rootNode.aorvoCurrentState && String(rootNode.aorvoCurrentState.variantId) !== String(selectedVariantId))) return;
    var selected = adapter().resolveSelectedBinding(projection, 'gid://shopify/ProductVariant/' + String(selectedVariantId));
    var native = variants.filter(function (variant) { return String(variant.id) === String(selectedVariantId); });
    if (selected.status !== 'OK' || !selected.binding || native.length !== 1 || !Array.isArray(selected.binding.OPTIONS) ||
        JSON.stringify(native[0].options) !== JSON.stringify(selected.binding.OPTIONS.map(function (option) { return option.value; }))) return;
    var options = selected.binding.OPTIONS.filter(function (option) { return option && typeof option.name === 'string' && typeof option.value === 'string' && !(option.name === 'Title' && option.value === 'Default Title'); });
    if (!options.length) return;
    var candidates = Array.from(rootNode.querySelectorAll('[data-aorvo-decision-role="Detail / Craftsmanship"]')).filter(function (module) {
      var figure = module.querySelector('[data-aorvo-approved-role="Detail / Craftsmanship"]');
      if (!figure || module.hidden) return false;
      var records = projection.MEDIA_ASSETS.filter(function (record) { return record.MEDIA_ROLE === 'Detail / Craftsmanship' && record.SHOPIFY_MEDIA_GID === 'gid://shopify/MediaImage/' + figure.getAttribute('data-aorvo-source-id'); });
      return records.length === 1 && !adapter().resolveReferenceApplicability(projection, records[0], selected.binding.SHOPIFY_VARIANT_GID).hidden;
    });
    if (candidates.length !== 1) return;
    var body = candidates[0].querySelector('.aorvo-pdp-decision-module__body');
    if (!body) return;
    var note = document.createElement('p');
    note.setAttribute('data-aorvo-selected-configuration-context', '');
    note.textContent = 'Selected configuration: ' + options.map(function (option) { return option.name + ': ' + option.value; }).join(' · ');
    body.prepend(note);
  }

  function render(rootNode, selectedVariantId) {
    if (rootNode && selectedVariantId != null && rootNode.aorvoCurrentState &&
        String(rootNode.aorvoCurrentState.variantId) !== String(selectedVariantId)) return;
    if (rootNode && selectedVariantId == null) {
      rootNode.querySelectorAll('[data-aorvo-configuration-dimension], [data-aorvo-configuration-key], [data-aorvo-approved-dimension-context], [data-aorvo-selected-configuration-context]').forEach(function (node) { node.remove(); });
      var unresolvedPanel = rootNode.querySelector('[data-aorvo-key-details-mode="contract"]');
      if (unresolvedPanel) unresolvedPanel.hidden = true;
      return;
    }
    if (rootNode && rootNode.hasAttribute('data-aorvo-public-display')) {
      var value=rootNode.aorvoPdpViewModel;
      var selected=value&&value.PUBLIC_DISPLAY_VIEW===1&&value.variants.find(function(v){return v.variantId==='gid://shopify/ProductVariant/'+String(selectedVariantId);});
      var module=rootNode.querySelector('[data-aorvo-decision-role="Dimension / Scale"]');
      var list=module&&module.querySelector('dl');
      if(module&&!list){list=document.createElement('dl');module.querySelector('.aorvo-pdp-decision-module__body')?.append(list);}
      if(list){list.replaceChildren();(selected?selected.dimensions:[]).forEach(function(item){var dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=item.label;dd.textContent=item.text;list.append(dt,dd);});}
      if(module){
        module.querySelectorAll('[data-aorvo-approved-dimension-context], [data-aorvo-selected-configuration-context]').forEach(function(n){n.remove();});
        var body=module.querySelector('.aorvo-pdp-decision-module__body');
        if(body&&selected&&selected.dimensionContext){var note=document.createElement('p');note.className='aorvo-pdp-approved-dimension-context';note.setAttribute('data-aorvo-approved-dimension-context','');note.textContent=selected.dimensionContext;body.append(note);}
        if(body&&selected&&selected.options.some(function(o){return o.value!=='Default Title';})){var selection=document.createElement('p');selection.setAttribute('data-aorvo-selected-configuration-context','');selection.textContent='Selected configuration: '+selected.options.map(function(o){return o.name+': '+o.value;}).join(' · ');body.prepend(selection);}
      }
      var materialModule=rootNode.querySelector('[data-aorvo-decision-role="Detail / Craftsmanship"]');
      var materialList=materialModule&&materialModule.querySelector('dl');
      var materialRows=selected?selected.facts.filter(function(f){return ['MATERIALS','MATERIALS_CRAFTSMANSHIP'].includes(f.group);}):[];
      if(materialModule&&!materialList&&materialRows.length){materialList=document.createElement('dl');materialList.className='aorvo-pdp-material-facts';materialModule.querySelector('.aorvo-pdp-decision-module__body')?.append(materialList);}
      if(materialList){materialList.replaceChildren();materialRows.forEach(function(item){var dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=item.label;dd.textContent=item.text;materialList.append(dt,dd);});}
      rootNode.querySelectorAll('[data-aorvo-approved-role]').forEach(function(figure){
        var id='gid://shopify/MediaImage/'+figure.getAttribute('data-aorvo-source-id');
        var media=selected&&selected.media.find(function(m){return m.mediaId===id;});
        figure.hidden=!media||media.hidden;figure.style.setProperty('display',figure.hidden?'none':'',figure.hidden?'important':'');
        var owner=figure.closest('[data-aorvo-decision-role]');if(owner&&media&&media.contextLabel)owner.querySelectorAll('.aorvo-pdp-canary__room-context').forEach(function(n){if(n.textContent.trim()===media.contextLabel)n.hidden=figure.hidden;});
      });
      var panel=rootNode.querySelector('[data-aorvo-key-details-mode="contract"]'),ul=panel&&panel.querySelector('ul');
      if(ul){ul.replaceChildren();(selected?selected.keyDetails:[]).forEach(function(item){var li=document.createElement('li'),label=document.createElement('span'),text=document.createElement('span');label.className='aorvo-pdp-key-label';text.className='aorvo-pdp-key-value';label.textContent=item.label+':';text.textContent=item.text;li.append(label,document.createTextNode(' '),text);ul.append(li);});panel.hidden=!selected||!selected.keyDetails.length;}
      return;
    }
    renderDimensions(rootNode, selectedVariantId);
    renderSelectedConfigurationContext(rootNode, selectedVariantId);
    var panel = rootNode && rootNode.querySelector('[data-aorvo-key-details-mode="contract"]');
    if (!panel) return;
    var list = panel.querySelector('ul');
    if (!list) return;
    var projection;
    try {
      projection = JSON.parse(panel.getAttribute('data-aorvo-key-details-payload') || '');
    } catch (_) {
      projection = null;
    }
    var result = resolve(projection, selectedVariantId);
    list.replaceChildren();
    result.items.forEach(function (item) {
      var row = document.createElement('li');
      var label = document.createElement('span');
      var value = document.createElement('span');
      label.className = 'aorvo-pdp-key-label';
      value.className = 'aorvo-pdp-key-value';
      label.textContent = item.label + ':';
      value.textContent = item.text;
      row.setAttribute('data-aorvo-key-fact', item.factId);
      row.append(label, document.createTextNode(' '), value);
      list.append(row);
    });
    panel.hidden = result.items.length === 0;
    panel.setAttribute('data-aorvo-key-details-status', result.status);
  }

  if (root) root.AorvoPdpKeyDetails = { resolve: resolve, render: render };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { resolve: resolve };
  }
})(typeof window === 'undefined' ? null : window);
